<template>
  <modal name="dataBoardModal" ref="refDataBoardModal"
      :width="this.modalWidth"
      :height="this.modalHeight"
      :draggable="!this.isMobile"
      :resizable="false"
      :reset="true"
      :scrollable="false"
      :clickToClose="false"
      :adaptive="true"
      :shiftX="this.modalShiftX"
      :shiftY="this.modalShiftY"
      @before-open="beforeOpen"
      @before-close="beforeClose"
      @opened="opened">
    <div id="layer-popup">
        <div class="popup-header">
            <h2>{{ areaName }} 데이터보드</h2>
            <button type="button" class="popup-close" @click="closeDataBoard()">
              <img src="../assets/web/images/icon_popup_close.png" alt="팝업닫기" title="팝업닫기">
            </button>
        </div>
        <div class="popup-cnt">
            <div class="graph01">
                <column-chart ref="refChart" :data="chartData" :options="chartOption" />
            </div>
            <div class="graph02">
                <grid ref="refGrid" :data="gridProps.data" :columns="gridProps.columns" :options="gridProps.options" />
            </div>
        </div>
    </div>
  </modal>
</template>

<script>
import 'tui-chart/dist/tui-chart.css'
import 'tui-grid/dist/tui-grid.css'
import { columnChart } from '@toast-ui/vue-chart'
import { Grid } from '@toast-ui/vue-grid'
import { eventBus } from '@/event-bus'
import { mapGetters } from 'vuex'
import mapApi from '@/api/web/MapApi'
import commonUI from '@/mixin/commonUI'

const statItemStore = 'statItemStore'

export default {
  name: 'DataBoard',
  components: {
    'column-chart': columnChart,
    grid: Grid
  },
  mixins: [commonUI],
  data () {
    return {
      isMobile: false,
      modalWidth: 540,
      modalHeight: 700,
      areaName: '',
      areaCd: '',
      mapSysNo: '',
      mapStatItems: [],
      mapStatItemYearList: [],
      chartData: {},
      chartOption: {
        chart: {
          width: 500,
          height: 300,
          title: '',
          format: '1,000'
        },
        xAxis: {
          title: '연도'
        },
        legend: {
          align: 'bottom'
        },
        chartExportMenu: {
          filename: 'data'
        },
        tooltip: {
          grouped: true
        }
      },
      gridProps: {
        data: [],
        columns: [],
        options: {
          header: {
            height: 30
          },
          bodyHeight: 250,
          selectionUnit: 'row',
          scrollY: true
        }
      }
    }
  },
  computed: {
    ...mapGetters(statItemStore, {
      selectedStatItems: 'selectedStatItems'
    }),

    // modalWidth() {
    //   if (this.isMobile) {
    //     return window.innerWidth - 10
    //   }
    //   return 540
    // },
    //
    // modalHeight() {
    //   if (this.isMobile) {
    //     return window.innerHeight - 10
    //   }
    //   return 700
    // },

    modalShiftX () {
      if (this.isMobile) {
        return 0.5
      }
      return 0.95
    },

    modalShiftY () {
      return 0.5
    }
  },
  created () {
    this.isMobile = this.isCheckMobile()
    if (this.isMobile) {
      this.modalWidth = window.innerWidth
      this.modalHeight = window.innerHeight

      // 모달 콘텐츠 높이 = (모달 세로 높이 - (모달 헤더 - padding(위/아래) - 차트 그리드 중간 공간) / 2)
      const modalContents = (this.modalHeight - 55 - 18 - 18 - 12) / 2

      // 모달 가로 넓이 - padding(위/아래) - border
      this.chartOption.chart.width = this.modalWidth - 18 - 18 - 4
      this.chartOption.chart.height = modalContents

      this.gridProps.options.bodyHeight = modalContents - this.gridProps.options.header.height
    }

    eventBus.$on('closeDataBoard', () => {
      this.closeDataBoard()
    })

    eventBus.$on('showDataBoard', (areaName, areaCd) => {
      this.areaName = areaName
      this.areaCd = areaCd
      this.chartOption.chartExportMenu.filename = this.areaName + '_데이터'
      this.mapStatItems = []

      for (const statItem of this.selectedStatItems) {
        if (statItem.srcCd === '2' && statItem.srcNo) {
          continue
        }
        this.mapStatItems.push(statItem)
      }

      // 통계항목에 선택된 연도 추출 후 선택된 연도 목록 생성
      let mapStatItemFullYearList = []
      for (const statItem of this.mapStatItems) {
        mapStatItemFullYearList = mapStatItemFullYearList.concat(statItem.years)
      }
      this.mapStatItemYearList = mapStatItemFullYearList.filter((item, index) => mapStatItemFullYearList.indexOf(item) === index)

      if (this.mapStatItems.length > 0 && this.mapStatItemYearList.length > 0) {
        this.showDataBoard()
        this.$modal.show('dataBoardModal')
      } else {
        this.closeDataBoard()
      }
    })

    eventBus.$on('sendDataBoard', () => {
      if (this.areaName === '' && this.areaCd === '') {
        return
      }

      this.mapStatItems = []
      for (const statItem of this.selectedStatItems) {
        if (statItem.srcCd === '2' && statItem.srcNo) {
          continue
        }
        this.mapStatItems.push(statItem)
      }

      if (this.mapStatItems.length > 0) {
        // 통계항목에 선택된 연도 추출 후 선택된 연도 목록 생성
        let mapStatItemFullYearList = []
        for (const statItem of this.mapStatItems) {
          mapStatItemFullYearList = mapStatItemFullYearList.concat(statItem.years)
        }
        this.mapStatItemYearList = mapStatItemFullYearList.filter((item, index) => mapStatItemFullYearList.indexOf(item) === index)

        const statItemCount = this.mapStatItems.length
        const statItemYearCount = this.mapStatItemYearList.length

        if (statItemCount === 0 || statItemYearCount === 0) {
          this.closeDataBoard()
          return
        }

        this.showDataBoard()
      } else {
        this.closeDataBoard()
      }
    })
  },

  mounted () {
  },

  beforeDestroy () {
    this.closeDataBoard()
  },

  methods: {
    closeDataBoard () {
      this.areaName = ''
      this.areaCd = ''
      this.$modal.hide('dataBoardModal')
    },

    showDataBoard () {
      const params = {
        sidoId: this.areaCd,
        fullYears: this.mapStatItemYearList,
        data: []
      }

      for (const mapItemData of this.mapStatItems) {
        const statItemParam = {
          mapSysNo: mapItemData.mapSysNo,
          mapItmNo: mapItemData.info.mapItmNo,
          years: mapItemData.years
        }
        params.data.push(statItemParam)
      }
      this.searchGridData(params)
      this.searchChartData(params)
    },

    searchChartData (params) {
      mapApi.searchColumnChatBoard(params).then(resultData => {
        this.chartData = resultData
      })
    },

    searchGridData (params) {
      mapApi.searchGridBoard(params).then(resultData => {
        const columns = [
          {
            header: '연도',
            name: 'year',
            align: 'center',
            width: 80
          }
        ]
        this.gridProps.columns = columns.concat(resultData.columns)
        this.gridProps.data = resultData.data

        this.$refs.refGrid.invoke('setColumns', columns.concat(resultData.columns))
        this.$refs.refGrid.invoke('resetData', resultData.data)
      })
    },

    beforeOpen (event) {
      // console.log('beforeOpen')
    },
    opened (event) {
      // console.log('opened')
    },
    beforeClose (event) {
      // console.log('beforeClose')
    }
  }
}
</script>

<style scoped>
.vm--container {
  width: 0px;
  height: 0px;
  z-index: 1000;
}

</style>

<style>
.vm--overlay[data-modal="dataBoardModal"] {
  width: 0px;
  height: 0px;
  background: transparent;
}
.tui-chart-group-tooltip table td {
  color: #ffffff;
  font-family: Arial;
  font-size: 12px;
  font-weight: 400;
}
</style>
